import type { Fanpage, FanpageFilterState } from '../../shared/types';
import { classifyFanpageTopic } from './topicClassifier';

export function filterBySearch(fanpages: Fanpage[], query: string): Fanpage[] {
  const q = query.trim().toLowerCase();
  if (!q) return fanpages;
  return fanpages.filter(fp => fp.name.toLowerCase().includes(q));
}

export function filterByStatus(fanpages: Fanpage[], status: FanpageFilterState['statusFilter']): Fanpage[] {
  if (status === 'Tất cả') return fanpages;
  return fanpages.filter(fp => fp.status === status);
}

export function filterByFollowRange(fanpages: Fanpage[], min: number | null, max: number | null): Fanpage[] {
  return fanpages.filter(fp => {
    if (min !== null && fp.follow < min) return false;
    if (max !== null && fp.follow > max) return false;
    return true;
  });
}

export function filterByPriceRange(fanpages: Fanpage[], min: number | null, max: number | null): Fanpage[] {
  return fanpages.filter(fp => {
    if (min !== null && fp.price < min) return false;
    if (max !== null && fp.price > max) return false;
    return true;
  });
}

export function filterByTopic(fanpages: Fanpage[], topic: string): Fanpage[] {
  if (!topic || topic === 'Tất cả') return fanpages;
  return fanpages.filter(fp => classifyFanpageTopic(fp.name) === topic);
}

export function applyFanpageFilters(fanpages: Fanpage[], state: FanpageFilterState): Fanpage[] {
  let result = fanpages;
  result = filterBySearch(result, state.searchQuery);
  result = filterByStatus(result, state.statusFilter);
  result = filterByFollowRange(result, state.minFollow, state.maxFollow);
  result = filterByPriceRange(result, state.minPrice, state.maxPrice);
  result = filterByTopic(result, state.topicFilter);
  return result;
}
